import React, { memo } from "react";
import useFaqPage from "./index.hooks";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Fab,
  Typography,
  Zoom,
} from "@material-ui/core";
import { ExpandMore, KeyboardArrowUp } from "@material-ui/icons";
import HomeIcon from "@material-ui/icons/Home";
import { Link as RouterLink } from "react-router-dom";
import Faqs from "models/Faqs";
import { ScrollTop } from "../../components";

type FaqPageProps = {};

const headline = "Domande frequenti";

const FaqPage = ({}: FaqPageProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    current,
    changeState,
    t,
    trigger,
    onScrollToTopFabClick,
    online,
  } = useFaqPage();

  return (
    <ScrollTop>
      <div className={styles.section}>
        <Container className={styles.rootContainer} maxWidth="lg">
          <Box id="back-to-top-anchor" py={3}>
            <Button
              variant="outlined"
              component={RouterLink}
              color="default"
              size="large"
              to="/"
              startIcon={<HomeIcon />}
            >
              Home
            </Button>
          </Box>
          <Box className={styles.titleContainer}>
            <Typography className={styles.title} variant="h2">
              {t(headline)}
            </Typography>
          </Box>
          <Box
            className={
              online ? styles.accordionContainer : styles.accordionContainerAlt
            }
          >
            {Faqs.data.map((item) => {
              return (
                <Accordion
                  key={item._id}
                  expanded={current === item._id}
                  onChange={changeState(item._id)}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography className={styles.heading}>
                      {item.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>{item.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        </Container>
        <Zoom in={trigger}>
          <Box
            onClick={onScrollToTopFabClick}
            role="presentation"
            className={online ? styles.fab : styles.fabAlt}
          >
            <Fab color="primary" size="medium" aria-label="scroll back to top">
              <KeyboardArrowUp />
            </Fab>
          </Box>
        </Zoom>
      </div>
    </ScrollTop>
  );
};

export default memo(FaqPage);
